let loginOverlay = null;
class LoginPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Open popup when clicking account icons
    document.querySelectorAll(".header__icon--account").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.showPopup();
      });
    });

    // Close popup when clicking the close button
    const closeButton = this.querySelectorAll(".close-button");
    if (closeButton) {
      closeButton.forEach((button) => {
        button.addEventListener("click", () => this.hidePopup());
      });
    }

    // Close popup when clicking outside of the popup container
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.hidePopup();
      }
    });
  }

  showPopup() {
    this.classList.remove("tw-hidden");
    this.classList.add("tw-flex");
    if (!loginOverlay) {
      loginOverlay = document.createElement("div");
      loginOverlay.id = "nav-overlay";
      loginOverlay.className = "tw-fixed  !tw-flex tw-inset-0";
      document.body.appendChild(loginOverlay);
      // Add click listener to close the menu
      loginOverlay.addEventListener("click", () => {
        this.classList.add("tw-hidden");
        this.classList.remove("tw-flex");
        document.body.classList.remove("no-scroll");
        loginOverlay.remove(); // Remove overlay from DOM
        loginOverlay = null;
      });
    } else {
      loginOverlay.remove();
      loginOverlay = null;
    }
    document.body.classList.add("no-scroll");
  }

  hidePopup() {
    this.classList.add("tw-hidden");
    this.classList.remove("tw-flex");
    document.body.classList.remove("no-scroll");
    if (loginOverlay) {
      loginOverlay.remove();
      loginOverlay = null;
    }
    document
      .querySelector(".login-info-container")
      .classList.remove("tw-hidden");
    document.querySelector(".login-info-container").classList.add("tw-flex");

    document
      .querySelector(".signup-info-container")
      .classList.remove("tw-flex");
    document.querySelector(".signup-info-container").classList.add("tw-hidden");

    document.querySelector(".otp-screen").classList.remove("tw-flex");
    document.querySelector(".otp-screen").classList.add("tw-hidden");

    updateButtonState(otpSubmitButton, false);
  }
}

// Define the custom element
customElements.define("login-popup", LoginPopup);

// Placeholder focus
const phoneInputs = document.querySelectorAll(".phone-input-auth");
const placeholderTexts = document.querySelectorAll(".placeholder-text");

const reEnterPhoneNumberButton = document.getElementById("reenter-phone");
if (phoneInputs.length && placeholderTexts.length) {
  phoneInputs.forEach((input, index) => {
    const placeholder = placeholderTexts[index];


    input.addEventListener("input", () => {
      placeholder.style.display = input.value ? "none" : "block";
  
      if (input.value.length == 10) {
        document.querySelector(".login-button").removeAttribute("disabled");
      } else {
        document
          .querySelector(".login-button")
          .setAttribute("disabled", "disabled");
      }
    });

    input.addEventListener("focus", () => {
      placeholder.style.display = "none";
    });

    input.addEventListener("blur", () => {
      if (!input.value) {
        placeholder.style.display = "block";
      }
    });

    placeholder.addEventListener("click", () => {
      input.focus();
    });
  });
}

// OTP Functionality

let otpSubmitButton = document.querySelector(".login-button");
let isRegister = false;
let otpDataForSignup;
const signupButton = document.querySelector(".signup-button");
const resendButton = document.querySelector(".resend-button");
const otpInputs = document.querySelectorAll(".otp-input");
const sendOTPUrl = "https://borosilotp.marmeto.com/api/login/otp/send";
let userPhoneInput, userPhoneInputValue, otpData;
let signupGoBackButton = document.querySelector(".go-back-signup");
function getPhoneInputValue() {
  userPhoneInput = document.querySelector("input[name=phone-input]");
  return userPhoneInput ? userPhoneInput.value : "";
}

function isValidPhoneNumber(phone) {
  return !Number.isNaN(Number(phone)) && phone.trim() !== "";
}

function prepareOtpData(phone) {
  return {
    phoneNumber: phone,
  };
}

function resetOtpInputs() {
  document.querySelectorAll(".otp-input").forEach((input) => {
    input.value = "";
    input.style.border = "1px solid #DCDCDC";
  });
}

function hideWrongOtpMessage() {
  const wrongOtp = document.querySelector(".wrong-otp");
  wrongOtp.classList.remove("tw-flex");
  wrongOtp.classList.add("tw-hidden");
}

function handleOtpRequest(isResend = false) {
  userPhoneInputValue = getPhoneInputValue();
  if (!isValidPhoneNumber(userPhoneInputValue)) {
    showToast("error", "invalid phone number");
    return;
  }

  otpData = prepareOtpData(userPhoneInputValue);
  if (isResend) {
    resetOtpInputs();
    hideWrongOtpMessage();

    if (isRegister) {
      handleFetchSignup(otpDataForSignup, signupButton);
    } else {
      fetchOTP(sendOTPUrl, otpData);
    }
  } else {
    updateButtonState(otpSubmitButton, true);
    fetchOTP(sendOTPUrl, otpData);
  }
}

// Submit OTP
otpSubmitButton?.addEventListener("click", () => {
  handleOtpRequest(false);
});

// Resend OTP
resendButton?.addEventListener("click", () => {
  handleOtpRequest(true);
});

async function fetchOTP(url, data) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (response.ok) {
      if (result.status === "SUCCESS") {
        showToast("success", result.message);
        updateButtonState(otpSubmitButton, false);
        initiateLoginFlow(data.phoneNumber);
      }
    } else {
      if (response.status === 400 && result.status === "NOT_FOUND") {
        showToast(
          "warning",
          "User not found. Please register before continuing."
        );
        initiateSignUpFlow(data.phoneNumber);
      } else {
        showToast("error", "Something went wrong!");
        updateButtonState(otpSubmitButton, false);
        throw new Error(result.message || "Something went wrong");
      }
    }
  } catch (error) {
    console.error("Error fetching OTP:", error.message);
    updateButtonState(otpSubmitButton, false);
    showToast("error", error.message);
  }
}

function updateButtonState(button, isFetching) {
  if (isFetching) {
    button.querySelector(".loader").classList.replace("tw-hidden", "tw-flex");
    button.querySelector(".continue-text").classList.add("tw-hidden");
    button.setAttribute("disabled", "true");
  } else {
    button.querySelector(".loader").classList.replace("tw-flex", "tw-hidden");
    button.querySelector(".continue-text").classList.remove("tw-hidden");
    button.removeAttribute("disabled");
  }
}

function initiateSignUpFlow(phoneNumber) {
  const loginInfoContainer = document.querySelector(".login-info-container");
  if (loginInfoContainer) {
    loginInfoContainer.classList.add("tw-hidden");
    loginInfoContainer.classList.remove("tw-flex");
  }

  const signUpInfoContainer = document.querySelector(".signup-info-container");
  if (signUpInfoContainer) {
    signUpInfoContainer.classList.add("tw-flex");
    signUpInfoContainer.classList.remove("tw-hidden");
    let userPhoneInput = document.querySelector(
      "input[name=phone-input-signup]"
    );
    userPhoneInput.value = phoneNumber;
    document
      .querySelector(".placeholder-text-signup")
      .classList.add("tw-hidden");

    const phoneInputSignup = document.querySelector(
      "input[name=phone-input-signup]"
    );

    phoneInputSignup.addEventListener("change", () => {
      if (phoneInputSignup.value === "") {
        document
          .querySelector(".placeholder-text-signup")
          .classList.add("tw-flex");
      } else {
        document
          .querySelector(".placeholder-text-signup")
          .classList.add("tw-hidden");
      }
    });
    if (signupButton) {
      signupButton.addEventListener("click", (e) => {
        e.preventDefault();
        updateButtonState(signupButton, true);

        let userEmail = document
          .querySelector("input[name=user-email]")
          .value.trim();
        let userFirstName = document
          .querySelector("input[name=user-first-name]")
          .value.trim();
        let userLastName = document
          .querySelector("input[name=user-last-name]")
          .value.trim();
        let userGender = document
          .querySelector("select[name=gender]")
          .value.trim();
        let userDOB = document
          .querySelector("input[name=user-dob]")
          .value.trim();

        otpDataForSignup = {
          firstName: userFirstName,
          lastName: userLastName,
          phoneNumber: userPhoneInput.value,
          email: userEmail,
          gender: userGender,
          dob: userDOB,
        };

        if (
          userDOB === "" ||
          userEmail === "" ||
          userFirstName === "" ||
          userLastName === "" ||
          userPhoneInput.value.trim() === ""
        ) {
          updateButtonState(signupButton, false);
          showToast("error", "Please provide all details");
          return;
        }

        const isFormValidated = validateForm(userDOB);
        if (isFormValidated) {
          handleFetchSignup(otpDataForSignup, signupButton);
        } else {
          updateButtonState(signupButton, false);
          showToast("error", "DOB cannot be in the future");
          return;
        }
      });
    }
  }
}

function validateForm(dobDate) {
  const selectedDate = new Date(dobDate);
  const today = new Date();
  selectedDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  return selectedDate <= today;
}

function initiateLoginFlow(phoneNumber) {
  const loginInfoContainer = document.querySelector(".login-info-container");
  loginInfoContainer && loginInfoContainer.classList.add("tw-hidden");
  loginInfoContainer && loginInfoContainer.classList.remove("tw-flex");

  showOTPScreen(phoneNumber, true);
}

async function handleFetchSignup(data, signupButton) {
  let url = "https://borosilotp.marmeto.com/api/register/capture";

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (response.ok && result.status === "SUCCESS") {
      showToast("success", result.message);
      isRegister = true;
      updateButtonState(signupButton, false);
      showOTPScreen(data.phoneNumber, false); // Show OTP screen for signup
    } else {
      showToast("error", result.message || "Signup failed");
      updateButtonState(signupButton, false);
    }
  } catch (error) {
    showToast("error", "Something went wrong during signup");
    updateButtonState(signupButton, false);
  }
}

function showOTPScreen(phoneNumber, isLoginTrue) {
  const signUpInfoContainer = document.querySelector(".signup-info-container");
  if (signUpInfoContainer && !isLoginTrue) {
    signUpInfoContainer.classList.add("tw-hidden");
    signUpInfoContainer.classList.remove("tw-flex");
  }

  const otpScreen = document.querySelector(".otp-screen");
  if (otpScreen) {
    otpScreen.classList.add("tw-flex");
    otpScreen.classList.remove("tw-hidden");
    const verifyOTPButton = document.querySelector(".verify-otp");
    let otpCode;
    otpScreen.querySelector(
      ".phone-number-text"
    ).innerHTML = `Sent a code at +91 ${maskPhoneNumber(
      phoneNumber
    )} type down the code below to continue`;

    otpInputs.forEach((input, index, inputs) => {
      input.addEventListener("input", (e) => {
        input.style.border = "1px solid #DCDCDC"; // Reset to gray when typing
        e.target.value = e.target.value.replace(/\D/g, ""); // Allow only numbers

        if (e.target.value.length > 1) {
          e.target.value = e.target.value.charAt(0); // Allow only one character
        }

        if (e.target.value && index < inputs.length - 1) {
          inputs[index + 1].focus(); // Move to next input
        }

        // Enable the button only if all inputs are filled
        otpCode = Array.from(inputs)
          .map((inp) => inp.value)
          .join("");

        if (otpCode.length === inputs.length) {
          inputs.forEach((inp, i) => (inp.value = otpCode[i] || ""));
          inputs[inputs.length - 1].focus();
          verifyOTPButton.removeAttribute("disabled");
        } else {
          verifyOTPButton.setAttribute("disabled", true);
          input.style.border = "1px solid  #DCDCDC";
        }
      });

      input.addEventListener("keydown", (e) => {
        // Prevent Up and Down arrow keys
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
          e.preventDefault();
        }

        // Move focus Left
        if (e.key === "ArrowLeft" && index > 0) {
          inputs[index - 1].focus();
        }

        // Move focus Right
        if (e.key === "ArrowRight" && index < inputs.length - 1) {
          inputs[index + 1].focus();
        }

        // Handle Backspace
        if (e.key === "Backspace" && !input.value && index > 0) {
          inputs[index - 1].focus();
        }
      });

      // Handle OTP Paste
      input.addEventListener("paste", (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData
          .getData("text")
          .trim()
          .replace(/\D/g, "");

        if (pastedData.length === inputs.length) {
          inputs.forEach((inp, i) => (inp.value = pastedData[i] || ""));
          inputs[inputs.length - 1].focus(); // Move focus to the last input
          verifyOTPButton.removeAttribute("disabled");
        }
      });
    });

    if (verifyOTPButton) {
      verifyOTPButton.addEventListener("click", (e) => {
        e.preventDefault();
        let wrongOtp = document.querySelector(".wrong-otp");
        wrongOtp.classList.remove("tw-flex");
        wrongOtp.classList.add("tw-hidden");
        let updatedPhoneNumber = getPhoneInputValue();
        handleVerifyOTP(otpCode, updatedPhoneNumber, verifyOTPButton);
      });
    }
  }
}

//  Function to Set Red Border on Incorrect OTP
function setErrorState() {
  otpInputs.forEach((input) => {
    input.style.border = "1px solid #FF0000";
  });
}

const otpContainer = document.querySelector(".otp-container");

// Function to Reset Border & Hide Wrong OTP Message
function handleTypingState() {
  if (otpContainer) {
    otpContainer.addEventListener("input", (e) => {
      if (e.target.classList.contains("otp-input")) {
        document.querySelectorAll(".otp-input").forEach((inp) => {
          inp.style.border = "1px solid #DCDCDC";
        });

        let wrongOtp = document.querySelector(".wrong-otp");
        if (wrongOtp) {
          wrongOtp.classList.remove("tw-flex");
          wrongOtp.classList.add("tw-hidden");
        }
      }
    });
  }
}

handleTypingState();

function maskPhoneNumber(phoneNumber) {
  const firstTwo = phoneNumber.slice(0, 2);
  const lastTwo = phoneNumber.slice(-2);
  return `${firstTwo}******${lastTwo}`;
}

async function handleVerifyOTP(otp, phoneNumber, verifyOTPButton) {
  try {
    let methodUsed = "Phone";
    let otpVerificationURL = isRegister
      ? "https://borosilotp.marmeto.com/api/register"
      : "https://borosilotp.marmeto.com/api/login/otp";

    const verificationData = {
      phoneNumber: phoneNumber,
      otp,
      redirectionUrl: "/",
    };

    const response = await fetch(otpVerificationURL, {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(verificationData),
    });

    const data = await response.json();

    if (data.status === "OTP_INVALID") {
      document.querySelectorAll(".otp-input").forEach((input) => {
        input.style.border = "1px solid #DF1C41";
      });

      let wrongOtp = document.querySelector(".wrong-otp");
      wrongOtp.classList.add("tw-flex");
      wrongOtp.classList.remove("tw-hidden");
      showToast("error", data.message);
      return;
    }

    if (data.status === "SUCCESS" && !data.url) {
      showToast("success", "OTP verified successfully!");
      updateButtonState(verifyOTPButton, false);
      document.querySelectorAll(".otp-input").forEach((input) => {
        input.style.border = "1px solid #40B49E";
      });

      setTimeout(() => {
        window.location.href = "/account/register";
      }, 1000);

      return;
    }

    if (data.url) {
      updateButtonState(verifyOTPButton, false);
      document.querySelectorAll(".otp-input").forEach((input) => {
        input.style.border = "1px solid #40B49E";
      });

      setTimeout(() => {
        window.location.href = data.url;
      }, 1000);

      showToast("success", "OTP verified successfully!");
    }
  } catch (error) {
    console.error("Error verifying OTP:", error);
    showToast("error", "Something went wrong. Please try again.");
    updateButtonState(verifyOTPButton, false);
  }
}

function showToast(type, message) {
  let toast;

  if (type === "success") {
    toast = document.getElementById("successToast");
    toast.innerHTML = `<svg class="toast-icon" fill="white" viewBox="0 0 24 24">
      <path d="M9 16.2l-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4z"/>
    </svg> 
    <p>${message}</p>`;
  } else if (type === "error") {
    toast = document.getElementById("errorToast");
    toast.innerHTML = `<svg class="toast-icon" fill="white" viewBox="0 0 24 24">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
    </svg>
    <p>${message}</p>`;
  } else if (type === "warning") {
    toast = document.getElementById("warningToast");
    toast.innerHTML = `<svg class="toast-icon" fill="white" viewBox="0 0 24 24">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v2h2v-2zm0-4h-2v3h2v-3z"/>
    </svg>
    <p>${message}</p>`;
  } else {
    console.warn("Invalid toast type!");
    return;
  }

  // Show the toast
  toast.classList.add("show");

  // Hide after 3 seconds
  setTimeout(() => {
    toast.classList.remove("show");
  }, 3000);
}

// Re-Enter Phone number
if (reEnterPhoneNumberButton) {
  reEnterPhoneNumberButton.addEventListener("click", (e) => {
    e.preventDefault();

    // Show the Login Screen
    const loginScreen = document.querySelector(".login-info-container");
    loginScreen.classList.add("tw-flex");
    loginScreen.classList.remove("tw-hidden");

    // Hide OTP Screen
    const otpScreen = document.querySelector(".otp-screen");
    otpScreen.classList.remove("tw-flex");
    otpScreen.classList.add("tw-hidden");

    isRegister = false;
    // Reserve the Phone Number in the input
    getPhoneInputValue();
    updateButtonState(otpSubmitButton, false);
  });
}
